var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.945 5.334 1.414 1.413L7.053 18.053 5.639 16.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.36 16.64-1.414 1.414L5.64 6.748l1.413-1.414z"
  })));
};

export { SvgCancel as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIxNi45NDUzIiB5PSI1LjMzMzk4IiB3aWR0aD0iMS45OTg2NiIgaGVpZ2h0PSIxNS45ODkzIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxNi45NDUzIDUuMzMzOTgpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgIDxyZWN0IHg9IjE4LjM1OTQiIHk9IjE2LjY0MDYiIHdpZHRoPSIxLjk5ODY2IiBoZWlnaHQ9IjE1Ljk4OTMiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxOC4zNTk0IDE2LjY0MDYpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";